export class InlineConfirmContainer {
	private elements: IInlineElement[] = [];

	addElement(button: IInlineElement) {
		this.elements.push(button);
	}

	hideElementsExcept(element: IInlineElement) {
		this.elements.forEach(el => {
			if (el === element) { return; }
			el.hide();
		});
	}

	showElements() {
		this.elements.forEach(btn => { btn.show(); });
	}
}

export interface IInlineElement {
	hide: () => void;
	show: () => void;
}
